import { ActionTypes as ThemeActionTypes } from '../../../config/theme/constants';
import { ActionTypes } from '../../actions/constants';

export const initialState = {};

export default function parametersReducer(state = initialState, action = {}) {
    switch (action.type) {
        case ActionTypes.RESET_FILTERS:
            return {
                ...state,
                filters: {},
            };

        case ActionTypes.UPDATE_PARAMETERS:
            return {
                ...state,
                ...action.payload,
            };

        case ThemeActionTypes.SET_THEME:
            return {
                ...state,
                directoryId: action.payload.directoryId,
            };

        default:
            return state;
    }
}
